import { http } from './http';

export type ThirdPartyLoginErrorMessage =
  | 'ALREADY_DONE'
  | 'TOKEN_ERROR'
  | 'LOGIN_FAILED';

/**
 * To send the token of facebook to check whether the user has completed the survey.
 *
 * @returns {string} - The facebookId of the logined user.
 */
export async function facebookLogin(
  svid: string,
  token: string
): Promise<string> {
  try {
    const url = http.url.api(`/s/fb-login`, 1);
    const body = new FormData();
    body.append('svid', svid);
    body.append('fb_token', token);
    const res = await http.post(url, { body });
    const { status, fb_id: fbId, errmsg = '' } = await http.handleResponse(res);

    if (!status) {
      throw new Error(errmsg);
    }

    return fbId;
  } catch (error) {
    throw error;
  }
}
